import React, { forwardRef, memo } from 'react'

import { useMediaQueries } from 'hooks'

import { symbols } from 'helpers/typograph'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'

const Headline = memo(
  forwardRef((_, ref): React.ReactElement => {
    const { desktop } = useMediaQueries()

    return (
      <Typography ref={ref} size={desktop ? 32 : 24} weight="semibold" lineHeight="small">
        <Typo>Application to transfer existing pension{symbols.nbsp}to InvestEngine</Typo>
      </Typography>
    )
  }),
)
Headline.displayName = 'Headline'

export { Headline }
